/* eslint-disable @typescript-eslint/no-empty-function */
'use client'

import buildSearchParams from '@/useCases/filters/buildSearchURL'
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'
import { AggregatesValue, IParamsByUrl } from '~types/search'
import actions from './actions'
import { SEARCH_V2_URL } from './constants'

type Action =
  | 'clearAll'
  | 'sortSelected'
  | 'changePage'
  | 'applyFilters'
  | 'removeFilter'

interface GoToSearchV2Props {
  router: AppRouterInstance
  urlParams: IParamsByUrl
  revalidatePath?: (url: string) => Promise<void>
  action: Action
  value?: string
  page?: number
  filters?: Record<string, AggregatesValue>
  filterValue?: string
  type?: string
}

const goToSearchV2 = async ({
  router,
  urlParams,
  revalidatePath = async () => {},
  action,
  value,
  page,
  filters,
  filterValue,
  type,
}: GoToSearchV2Props) => {
  const { push, refresh } = router

  const buildParams = actions[action]

  const newParams = buildParams({
    urlParams,
    value,
    page,
    filters,
    filterValue,
    type,
  })

  const searchParams = buildSearchParams(newParams)

  await revalidatePath(SEARCH_V2_URL)

  push(`${SEARCH_V2_URL}?${searchParams}`)
  refresh()
}

export default goToSearchV2
